import {DropdownItem} from '@eitje/web_components'

export const InvoicesRowDropdown = ({row}) => {
	const {billing_info_id, id} = row.original

	return (
		<>
			<DropdownItem iconLeft="pencil" t="invoices.update_status" modalLink={`/billing/unpaid_invoices/${id}/edit`} />
			<DropdownItem
				iconLeft="external-link"
				t="invoices.show_billing_info"
				to={`/billing/billing_infos/${billing_info_id}`}
				disabled={!billing_info_id && 'no_billing_info_id'}
			/>
		</>
	)
}
